<template>
    <q-list>
      <q-img src="img/cards.png" style="width: 100%; height: 135px">
      <!-- <div class="absolute-bottom text-subtitle1">
          <div class="row">
              <div class="col col-md-12">
                  <span class="h_card_sidebar1">NAMA KECAMATAN</span>
              </div>
          </div>
      </div> -->
    </q-img>

    <q-item-label class="bg-cyan-8" header><span style="color:white;" class="text-bold">{{profile.nama}}</span></q-item-label>

    <q-item clickable to="/" exact >
      <q-item-section top avatar>
        <q-avatar color="cyan-8" text-color="white" icon="dashboard" />
      </q-item-section>
      <q-item-section>
        <q-item-label>Dashboard</q-item-label>
      </q-item-section>
    </q-item>
    <q-item clickable to="/laporan" v-if="profile.id_pengguna == 'Administrator'" exact >
      <q-item-section top avatar>
        <q-avatar icon="light_mode" color="light-blue-7" text-color="white" />
      </q-item-section>
      <q-item-section>
        <q-item-label>Laporan</q-item-label>
      </q-item-section>
    </q-item>
    <q-item clickable to="/artikel" v-if="profile.id_pengguna == 'Administrator'" exact >
      <q-item-section top avatar>
        <q-avatar icon="library_books" color="light-blue-7" text-color="white" />
      </q-item-section>
      <q-item-section>
        <q-item-label>Artikel</q-item-label>
      </q-item-section>
    </q-item>
    <q-item clickable to="/infografis" v-if="profile.id_pengguna == 'Administrator'" exact >
      <q-item-section top avatar>
        <q-avatar icon="images" color="light-blue-7" text-color="white" />
      </q-item-section>
      <q-item-section>
        <q-item-label>Infografis</q-item-label>
      </q-item-section>
    </q-item>
    <q-item clickable to="/tentang" v-if="profile.id_pengguna == 'Administrator'" exact >
      <q-item-section top avatar>
        <q-avatar icon="info_outline" color="light-blue-7" text-color="white" />
      </q-item-section>
      <q-item-section>
        <q-item-label>Tentang</q-item-label>
      </q-item-section>
    </q-item>
     <q-expansion-item :content-inset-level="1" v-if="profile.id_pengguna == 'Administrator'" >

      <template v-slot:header>
        <q-item-section avatar>
          <q-avatar icon="settings_applications" color="light-blue-7" text-color="white" />
        </q-item-section>
        <q-item-section>Data Master</q-item-section>
      </template>
      
      <q-list :content-inset-level="0.5" > 

        <q-item clickable to="/jenis_laporan" :content-inset-level="0.5"  >
          <q-item-section>Jenis Laporan</q-item-section>
        </q-item>

        <q-item clickable to="/kategori_artikel" :content-inset-level="0.5"  >
          <q-item-section>Kategori Artikel</q-item-section>
        </q-item>

        <q-item clickable to="/pengguna" :content-inset-level="0.5"  >
          <q-item-section>Pengguna</q-item-section>
        </q-item>

      </q-list>
    </q-expansion-item>

    <q-item clickable @click="logout" exact>
      <q-item-section top avatar>
        <q-avatar color="red-7" text-color="white" icon="exit_to_app" />
      </q-item-section>
      <q-item-section>
        <q-item-label class="text-red">Logout</q-item-label>
        <!-- <q-item-label caption lines="2">Logout</q-item-label> -->
      </q-item-section>
    </q-item>
      </q-list>
</template>

<script>
export default {
  data() {
    return {
      // user: "",
      profile : {
					nama : '',
					id_pengguna : '',
          unitKerja : '',
				},
    };
  },

  methods: {
    logout : function(){
        localStorage.removeItem('token');
        localStorage.removeItem('profile');
        this.$router.push('/login');
    },
  },
  mounted: function(){
    var get_profile = JSON.parse(localStorage.profile);

    console.log(get_profile);
    // this.profile.unit_kerja = get_profile.profile.unit_kerja_nama;
    this.profile.nama = get_profile.profile.nama;
    this.profile.id_pengguna = get_profile.profile.id_pengguna;
    // this.profile.unitKerja = get_profile.profile.unit_kerja_id;
  },
  
};
</script>